import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { colors, radius } from '../theme';

const API = 'https://api.eighteen-media.id';

export default function Artists() {
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newName, setNewName] = useState('');
  const [newNotes, setNewNotes] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const fetchArtists = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/api/artists`);
      setArtists(res.data || []);
    } catch (e) {
      setError('Gagal memuat daftar artis');
    }
    setLoading(false);
  };

  useEffect(() => { fetchArtists(); }, []);

  const createArtist = async () => {
    if (!newName.trim()) return;
    setSaving(true);
    try {
      await axios.post(`${API}/api/artists`, { name: newName.trim(), notes: newNotes.trim() || null });
      setNewName(''); setNewNotes(''); setShowAddModal(false);
      fetchArtists();
    } catch (e) {
      setError(e.response?.data?.error || 'Gagal menambah artis');
    }
    setSaving(false);
  };

  const uploadAvatar = async (id, file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append('avatar', file);
    try {
      await axios.post(`${API}/api/artists/${id}/avatar`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      fetchArtists();
    } catch (e) {
      // Server sekarang mengirim alasannya (ukuran/format), jadi tampilkan apa adanya.
      setError(e.response?.data?.error || 'Gagal upload foto artis');
    }
  };

  const deleteArtist = async (id, name) => {
    if (!window.confirm(`Hapus artis "${name}"? Channel yang terhubung tidak akan ikut terhapus, hanya jadi belum ter-assign.`)) return;
    try {
      await axios.delete(`${API}/api/artists/${id}`);
      fetchArtists();
    } catch (e) {
      setError('Gagal menghapus artis');
    }
  };

  return (
    <div style={{ paddingBottom: 40 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20, flexWrap: 'wrap', gap: 10 }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: colors.textPrimary, display: 'flex', alignItems: 'center', gap: 8 }}>
            <i className="ti ti-users-group" style={{ fontSize: 22 }}></i>Roster Artis
          </h1>
          <p style={{ fontSize: 13, color: colors.textSecondary, marginTop: 2 }}>Kelompokkan channel per-artis untuk laporan dan pengelolaan yang lebih rapi.</p>
        </div>
        <button onClick={() => setShowAddModal(true)} className="btn btn-gold" style={{ fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 }}>
          <i className="ti ti-plus" style={{ fontSize: 15 }}></i>Tambah Artis
        </button>
      </div>

      {error && (
        <div style={{ padding: '10px 14px', background: colors.dangerMuted, color: colors.danger, borderRadius: radius.md, marginBottom: 16, fontSize: 13 }}>{error}</div>
      )}

      {loading ? (
        <div style={{ textAlign: 'center', padding: 60, color: colors.textSecondary }}>Memuat roster artis...</div>
      ) : artists.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, color: colors.textSecondary, background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.lg }}>
          <i className="ti ti-users-group" style={{ fontSize: 40, marginBottom: 10, display: 'block' }}></i>
          Belum ada artis terdaftar. Klik "Tambah Artis" untuk mulai mengelompokkan channel.
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 14 }}>
          {artists.map(a => (
            <div key={a.id} style={{ background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.lg, padding: 18 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
                <label style={{ width: 44, height: 44, borderRadius: '50%', background: colors.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 17, color: '#FFFFFF', flexShrink: 0, cursor: 'pointer', overflow: 'hidden', position: 'relative' }} title="Klik untuk ganti foto">
                  {a.avatar_url ? (
                    <img src={`https://api.eighteen-media.id${a.avatar_url}`} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (
                    a.name.charAt(0).toUpperCase()
                  )}
                  <input type="file" accept="image/*" style={{ display: 'none' }}
                    onChange={e => { uploadAvatar(a.id, e.target.files[0]); e.target.value = ''; }} />
                </label>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 15, fontWeight: 700, color: colors.textPrimary, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.name}</div>
                  {a.notes && <div style={{ fontSize: 11, color: colors.textSecondary, marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.notes}</div>}
                </div>
                <button onClick={() => deleteArtist(a.id, a.name)} style={{ background: 'transparent', border: 'none', color: colors.danger, cursor: 'pointer', padding: 4, flexShrink: 0 }}>
                  <i className="ti ti-trash" style={{ fontSize: 16 }}></i>
                </button>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                {[
                  { icon: 'ti-brand-youtube', color: '#FF0000', count: a.yt_count },
                  { icon: 'ti-brand-instagram', color: '#E1306C', count: a.ig_count },
                  { icon: 'ti-brand-tiktok', color: '#000000', count: a.tt_count },
                ].map((p, i) => (
                  <div key={i} style={{ flex: 1, textAlign: 'center', padding: '8px 4px', background: colors.bgCardMuted, borderRadius: 8 }}>
                    <i className={`ti ${p.icon}`} style={{ fontSize: 15, color: p.color }}></i>
                    <div style={{ fontSize: 13, fontWeight: 700, color: colors.textPrimary, marginTop: 2 }}>{p.count}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      {showAddModal && (
        <div onClick={() => setShowAddModal(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: colors.bgCard, borderRadius: radius.lg, padding: 24, maxWidth: 400, width: '100%' }}>
            <h2 style={{ fontSize: 16, fontWeight: 700, color: colors.textPrimary, marginBottom: 16 }}>Tambah Artis Baru</h2>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, color: colors.textSecondary, marginBottom: 6 }}>Nama Artis <span style={{ color: colors.danger }}>*</span></label>
              <input type="text" placeholder="Nama artis..." value={newName} onChange={e => setNewName(e.target.value)} style={{ width: '100%' }} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, color: colors.textSecondary, marginBottom: 6 }}>Catatan (opsional)</label>
              <textarea placeholder="Catatan tambahan..." value={newNotes} onChange={e => setNewNotes(e.target.value)}
                style={{ width: '100%', minHeight: 60, background: colors.bgCardMuted, border: `1px solid ${colors.border}`, borderRadius: 8, color: colors.textPrimary, padding: '8px 12px', fontSize: 13, resize: 'vertical', boxSizing: 'border-box' }} />
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setShowAddModal(false)} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: `1px solid ${colors.borderStrong}`, background: colors.bgCard, color: colors.textPrimary, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Batal</button>
              <button onClick={createArtist} disabled={saving || !newName.trim()} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: 'none', background: (saving || !newName.trim()) ? colors.border : colors.accent, color: '#FFFFFF', fontSize: 13, fontWeight: 700, cursor: (saving || !newName.trim()) ? 'not-allowed' : 'pointer' }}>{saving ? 'Menyimpan...' : 'Simpan'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
